<template>
  <v-layout>
    <div class="col-12">
      <v-data-table
          mobile-breakpoint="768"
          :headers="headers"
          :items="imports"
          :loading="loading"
          class="elevation-1"
          :footer-props="footerProps"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>{{ $t('imports') }}</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-btn color="primary" dark class="mb-2" @click="openCreate">
              {{ $t('create') }}
            </v-btn>
            <Confirmationdialog
                :visible="dialogDelete"
                @confirmationdialog:cancelClick="closeDelete"
                @confirmationdialog:confirmClick="deleteItemConfirm"
            >
              <template v-slot:cardText>{{ $t('are_you_sure_delete') }}</template>
            </Confirmationdialog>
          </v-toolbar>
        </template>
        <!-- eslint-disable-next-line -->
        <template v-slot:item.actions="{ item }">
          <v-icon size="19" class="mr-2" @click="testItem(item)">mdi-eye</v-icon>
          <v-icon size="19" class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
          <v-icon size="19" @click="deleteItem(item)">mdi-delete</v-icon>
        </template>
      </v-data-table>

      <v-dialog v-model="dialog" max-width="600px" persistent>
        <v-card>
          <validation-observer ref="observer" v-slot="{ invalid }">
            <v-form @submit.prevent="save">
              <v-card-title class="dialog-title">
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <validation-provider v-slot="{ errors }" :name="$t('title')" rules="required">
                        <v-text-field
                            :error-messages="errors"
                            v-model="editedItem.title"
                            :label="$t('title')"
                        ></v-text-field>
                      </validation-provider>
                    </v-col>
                    <v-col cols="12">
                      <validation-provider v-slot="{ errors }" :name="$t('import_file_count')" rules="required|numeric|min_value:1">
                        <v-text-field
                            :error-messages="errors"
                            v-model="editedItem.fileCount"
                            :label="$t('import_file_count')"
                            @input="syncFileLabels"
                        ></v-text-field>
                      </validation-provider>
                    </v-col>
                    <v-col cols="12" v-for="(label, i) in editedItem.fileLabels" :key="'fl' + i">
                      <validation-provider v-slot="{ errors }" :name="$t('import_file_name') + ' ' + (i + 1)" rules="required">
                        <v-text-field
                            :error-messages="errors"
                            v-model="editedItem.fileLabels[i]"
                            :label="$t('import_file_name') + ' ' + (i + 1)"
                        ></v-text-field>
                      </validation-provider>
                    </v-col>
                    <v-col cols="12">
                      <validation-provider v-slot="{ errors }" :name="$t('import_prompt')" rules="required">
                        <v-textarea
                            :error-messages="errors"
                            v-model="editedItem.prompt"
                            :label="$t('import_prompt')"
                            rows="12"
                        ></v-textarea>
                      </validation-provider>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="cancel-button px-3" text @click="close">{{ $t('cancel') }}</v-btn>
                <v-btn
                    class="confirm-button px-5"
                    text
                    type="submit"
                    :disabled="invalid"
                    :loading="inuse"
                >{{ $t('save') }}</v-btn>
              </v-card-actions>
            </v-form>
          </validation-observer>
        </v-card>
      </v-dialog>

      <v-dialog v-model="testDialog" max-width="600px" persistent>
        <v-card>
          <validation-observer ref="testObserver" v-slot="{ invalid }">
            <v-form @submit.prevent="submitTest">
              <v-card-title class="dialog-title">
                <span class="headline">{{ $t('build_plan') }}<template v-if="testImportItem"> — {{ testImportItem.title }}</template></span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" v-for="(label, i) in (testImportItem ? testImportItem.fileLabels : [])" :key="'tf' + i">
                      <validation-provider v-slot="{ errors }" :name="label || ($t('file') + ' ' + (i + 1))" rules="required|ext:csv">
                        <v-file-input
                            v-model="testFiles[i]"
                            accept=".csv"
                            :error-messages="errors"
                            truncate-length="15"
                            :label="label || ($t('file') + ' ' + (i + 1))"
                        ></v-file-input>
                      </validation-provider>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="cancel-button px-3" text @click="closeTest">{{ $t('cancel') }}</v-btn>
                <v-btn
                    class="confirm-button px-5"
                    text
                    type="submit"
                    :disabled="invalid"
                    :loading="testInUse"
                >{{ $t('run') }}</v-btn>
              </v-card-actions>
            </v-form>
          </validation-observer>
        </v-card>
      </v-dialog>

      <Informationdialog
          :title="$t('plan_result_title')"
          :text="buildPlanResultText"
          :visible="buildPlanResultDialog"
          @informationdialog:buttonClick="buildPlanResultDialog = false"
      />
    </div>
  </v-layout>
</template>
<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { apiCall } from "@/utils/api.js";
import { mapActions } from "vuex";
import Confirmationdialog from "@/components/ConfirmationDialog";
import Informationdialog from "@/components/InformationDialog";

export default {
  name: "Imports",
  components: { ValidationProvider, ValidationObserver, Confirmationdialog, Informationdialog },
  data(context) {
    return {
      footerProps: { "items-per-page-options": [10, 20, 50] },
      inuse: false,
      dialog: false,
      dialogDelete: false,
      loading: true,
      imports: [],
      headers: [
        { text: context.$t('id'), align: "start", sortable: false, value: "id" },
        { text: context.$t('title'), sortable: false, value: "title" },
        { text: context.$t('actions'), value: "actions", sortable: false },
      ],
      editedIndex: -1,
      editedItem: { id: 0, title: "", fileCount: 0, fileLabels: [], prompt: "" },
      defaultItem: { id: 0, title: "", fileCount: 0, fileLabels: [], prompt: "" },
      testDialog: false,
      testImportItem: null,
      testFiles: [],
      testInUse: false,
      buildPlanPollTimer: null,
      buildPlanResultDialog: false,
      buildPlanResultText: "",
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? this.$t("create") : this.$t("edit");
    },
  },
  watch: {
    dialog(val) { val || this.close(); },
    dialogDelete(val) { val || this.closeDelete(); },
  },
  mounted() {
    this.getDataFromApi();
  },
  methods: {
    ...mapActions("service", ["setSnackbar"]),
    getDataFromApi() {
      this.loading = true;
      apiCall("get", "imports", {}, true).then((response) => {
        this.imports = (response.data && response.data.result) ? response.data.result : [];
        this.loading = false;
      });
    },
    syncFileLabels() {
      const n = Math.max(0, parseInt(this.editedItem.fileCount) || 0);
      const arr = (this.editedItem.fileLabels || []).slice(0, n);
      while (arr.length < n) arr.push("");
      this.$set(this.editedItem, 'fileLabels', arr);
    },
    openCreate() {
      this.editedIndex = -1;
      this.editedItem = { id: 0, title: "", fileCount: 0, fileLabels: [], prompt: "" };
      this.dialog = true;
    },
    editItem(item) {
      this.editedIndex = item.id;
      this.editedItem = {
        id: item.id,
        title: item.title,
        fileCount: item.fileCount,
        fileLabels: Array.isArray(item.fileLabels) ? item.fileLabels.slice() : [],
        prompt: item.prompt,
      };
      this.dialog = true;
    },
    deleteItem(item) {
      this.editedIndex = item.id;
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    deleteItemConfirm() {
      this.loading = true;
      apiCall("post", "imports/delete", { data: { id: this.editedItem.id } }, true).then((response) => {
        this.setSnackbar({
          color: response.data && response.data.status ? "success" : "error",
          text: response.data && response.data.status ? this.$t('import_deleted') : response.data.result,
          toggle: true,
        });
        this.getDataFromApi();
      });
      this.closeDelete();
    },
    save() {
      const payload = {
        id: this.editedIndex > -1 ? this.editedItem.id : null,
        title: this.editedItem.title,
        fileCount: parseInt(this.editedItem.fileCount) || 0,
        fileLabels: this.editedItem.fileLabels,
        prompt: this.editedItem.prompt,
      };
      const url = this.editedIndex > -1 ? "imports/update" : "imports/create";
      this.inuse = true;
      apiCall("post", url, { data: payload }, true).then((response) => {
        this.inuse = false;
        if (response && response.data && response.data.status) {
          this.setSnackbar({ color: "success", text: this.$t('import_saved'), toggle: true });
          this.getDataFromApi();
          this.close();
        } else {
          this.setSnackbar({ color: "error", text: response.data.result, toggle: true });
        }
      }).catch(() => {
        this.inuse = false;
        this.setSnackbar({ color: "error", text: this.$t('unknown_error'), toggle: true });
      });
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = { id: 0, title: "", fileCount: 0, fileLabels: [], prompt: "" };
        this.editedIndex = -1;
        if (this.$refs.observer) this.$refs.observer.reset();
      });
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = { id: 0, title: "", fileCount: 0, fileLabels: [], prompt: "" };
        this.editedIndex = -1;
      });
    },
    testItem(item) {
      this.testImportItem = {
        id: item.id,
        title: item.title,
        fileLabels: Array.isArray(item.fileLabels) ? item.fileLabels.slice() : [],
      };
      this.testFiles = [];
      this.testDialog = true;
    },
    submitTest() {
      const formData = new FormData();
      formData.append("id", this.testImportItem.id);
      this.testFiles.forEach((f) => { if (f) formData.append("files", f); });
      this.testInUse = true;
      apiCall("post", "imports/build-plan", formData, true, "text", { "Content-Type": "multipart/form-data" }, false)
        .then(() => {
          this.pollBuildPlan();
        })
        .catch((errResp) => {
          this.testInUse = false;
          const msg = (errResp && errResp.data && typeof errResp.data === "string") ? errResp.data : this.$t('unknown_error');
          this.setSnackbar({ color: "error", text: msg, toggle: true });
        });
    },
    pollBuildPlan() {
      if (this.buildPlanPollTimer) {
        clearTimeout(this.buildPlanPollTimer);
        this.buildPlanPollTimer = null;
      }
      apiCall("get", "imports/build-plan/status", {}, true)
        .then((response) => {
          const status = response.data && response.data.status;
          if (status === "DONE") {
            this.downloadBuildPlanResult();
          } else if (status === "FAILED") {
            this.testInUse = false;
            const msg = (response.data && response.data.error) || this.$t('plan_build_failed');
            this.showBuildPlanResult(this.$t('plan_build_failed') + " " + msg);
          } else if (status === "PENDING" || status === "RUNNING") {
            this.buildPlanPollTimer = setTimeout(() => this.pollBuildPlan(), 2000);
          } else {
            this.testInUse = false;
          }
        })
        .catch(() => {
          this.testInUse = false;
          this.showBuildPlanResult(this.$t('plan_build_status_lost'));
        });
    },
    downloadBuildPlanResult() {
      apiCall("get", "imports/build-plan/result", {}, true, "blob")
        .then((response) => {
          this.testInUse = false;
          const blob = new Blob([response.data], { type: "text/csv" });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = this.buildTestFileName();
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
          this.closeTest();
          this.showBuildPlanResult(this.$t('plan_build_success'));
        })
        .catch(() => {
          this.testInUse = false;
          this.showBuildPlanResult(this.$t('plan_build_status_lost'));
        });
    },
    showBuildPlanResult(text) {
      this.buildPlanResultText = text;
      this.buildPlanResultDialog = true;
    },
    buildTestFileName() {
      const rawTitle = this.testImportItem && this.testImportItem.title ? this.testImportItem.title : "import";
      const title = rawTitle.replace(/[^a-zA-Z0-9_\- ]/g, "").trim().replace(/\s+/g, "_") || "import";
      const ts = new Date().toISOString().slice(0, 19).replace(/[:T]/g, "-");
      return title + "_" + ts + ".csv";
    },
    closeTest() {
      if (this.buildPlanPollTimer) {
        clearTimeout(this.buildPlanPollTimer);
        this.buildPlanPollTimer = null;
      }
      this.testDialog = false;
      this.$nextTick(() => {
        this.testFiles = [];
        this.testImportItem = null;
        if (this.$refs.testObserver) this.$refs.testObserver.reset();
      });
    },
  },
};
</script>
